<template>
    <div class="mt-4">
        <!-- <div class="columns is-vcentered is-mobile pagination"> -->
        <alert-container :messages="msgs" />
        <div class="pagination-content">
            <div class="pagination-left">
                <b-pagination
                    v-model="currentPage"
                    :total="totalItems"
                    :per-page="perPage"
                    order="is-centered"
                    @change="onselectPageBtn"
                    :simple="simple"
                />
                <div class="pagination-input">
                    <input
                        ref="paginadorInput"
                        class="input"
                        type="text"
                        maxlength="4"
                        v-mask="'####'"
                        v-model="currentPageInput"
                        @input="debouncedOnSearch(currentPageInput)"
                        v-show="numPages > 1"
                        :title="$t('numero-da-pagina')"
                    />
                </div>
            </div>
            <div class="pagination-rigth" v-show="!simple">
                <div :class="{ 'no-selectable': !selectable }">
                    {{ getLabel() }}
                </div>
                <div v-show="selectable">
                    <span class="pagination-item">{{ `${$t('itens-por-pagina')}:` }}</span>
                    <b-select
                        class="select-perpage pagination-item"
                        size="is-small"
                        :disabled="disabled"
                        :value="perPageSelected"
                        @input="onSelectPerPage"
                    >
                        <option v-for="item in getOptions()" :value="item" :key="item.label">
                            {{ item.label }}
                        </option>
                    </b-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from '@/models/Message';
export default {
    props: {
        totalItems: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        resetPagination: {
            type: Boolean,
            default: false,
        },
        selectable: {
            type: Boolean,
            default: true,
        },
        perPageOptions: {
            type: Array,
            default: [10, 25, 50, 100],
        },
        optionStarted: {
            type: Number,
            default: 0,
        },
        simple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            debouncedOnSearch: null,
            perPage: 10,
            currentPage: 1,
            mudouDados: false,
            currentPageInput: null,
            initialItem: 1,
            finalItem: 1,
            numPages: 1,
            msgs: [],
        };
    },
    created() {
        if (this.totalItems > 0) this.currentPageInput = this.currentPage;
        // Seleciona o valor na posição do array de opções de paginação
        this.perPageSelected = this.getOptions()[this.optionStarted];
        this.perPage = this.perPageSelected['label'];
        this.debouncedOnSearch = this.debounce(this.onSelectPage, 1000);
    },
    watch: {
        currentPage() {
            if (this.totalItems > 0) this.currentPageInput = this.currentPage;
        },
        totalItems() {
            if (this.totalItems > 0) this.currentPageInput = this.currentPage;
        },
        resetPagination(val) {
            if (val) this.onselectPageBtn(1);
        },
    },
    methods: {
        getOptions() {
            return this.perPageOptions.map((i) => {
                return { label: i };
            });
        },
        onSelectPerPage(selectedObj) {
            if (this.perPageSelected !== selectedObj) {
                this.mudouDados = true;
                this.perPageSelected = selectedObj;
                this.perPage = selectedObj['label'];
                this.onSelectPage(1);
                this.emit();
            }
        },
        onselectPageBtn(pageNumber) {
            this.mudouDados = true;
            this.currentPage = pageNumber;
            this.emit();
        },
        onSelectPage(pageNumber) {
            if (!isNaN(+pageNumber) && +pageNumber != 0 && +pageNumber <= this.numPages) {
                if (+pageNumber != this.currentPage) {
                    this.currentPage = +pageNumber;
                    if (!this.mudouDados) {
                        this.mudouDados = true;
                        this.emit();
                    }
                }
            } else if (!isNaN(+pageNumber) && +pageNumber > this.numPages && this.totalItems > 0) {
                this.currentPageInput = this.currentPage;
                this.msgs.push(new Message('alert', 'pagina-digitada-maior-maxima', true));
            } else if (!isNaN(+pageNumber) && this.totalItems > 0) {
                this.currentPageInput = this.currentPage;
                this.msgs.push(new Message('alert', 'digite-uma-pagina-valida', true));
            } else {
                this.currentPageInput = this.currentPage;
            }
        },
        emit() {
            if (this.mudouDados) {
                this.mudouDados = false;
                this.$emit('change', {
                    currentPage: this.currentPage,
                    perPage: this.perPage,
                });
            }
        },
        getLabel() {
            this.numPages = Math.ceil(this.totalItems / this.perPage);
            this.initialItem = this.totalItems > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            this.finalItem =
                this.initialItem - 1 + this.perPage > this.totalItems
                    ? this.totalItems
                    : this.initialItem - 1 + this.perPage;
            return `${this.initialItem} - ${this.finalItem} / ${this.totalItems} ${this.$t(
                this.totalItems > 1 ? 'resultados' : 'resultado'
            )}`;
        },
    },
};
</script>

<style lang="scss">
.pagination-content {
    position: relative;
    clear: both;
    width: 100% !important;
    display: flex;

    @media screen and (max-width: 900px) {
        flex-direction: column;
        & > * {
            align-self: center;
        }
    }

    .pagination-left {
        flex-grow: 1;
        display: flex;
        margin-top: 10px;

        .pagination {
            margin: 0;
            padding: 0;
            .pagination-list {
                align-items: baseline;
            }
            @media screen and (max-width: 778px) {
                .pagination-previous,
                .pagination-next,
                .pagination-link,
                .pagination-ellipsis {
                    margin: 0 0.25rem;
                }
            }
        }

        .pagination-input {
            .input {
                text-align: center;
                max-width: 44px;
                height: 35px;
                border-radius: 4px !important;
                font-size: 0.87rem !important;
                margin-left: 5px;
                @media screen and (max-width: 778px) {
                    padding-left: 0.75em;
                    padding-right: 0.75em;
                }
            }
        }
    }

    .pagination-rigth {
        margin-top: 10px;
        margin-bottom: 10px;
        .select-perpage {
            max-width: 70px;
            margin-left: 5px;
            margin-right: 0px;
            padding-right: 0px;
            display: inline-flex !important;
        }
        .no-selectable {
            margin-top: 15px;
        }
    }
}
</style>
